import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SharedModule } from '@modules/shared/shared.module';

@Component({
  selector: 'app-legal-card-header',
  templateUrl: './legal-card-header.component.html',
  styleUrls: ['./legal-card-header.component.scss'],
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalCardHeaderComponent {
  readonly icon = input('');
  readonly cardTitle = input('');
  readonly subtitle = input('');
  readonly maxSize = input(45);
}
